import React, { Component } from 'react';
import Header from '../components/header';
import StationService from '../services/station_service';
import path from 'path-browserify';
import { Link } from 'react-router-dom';
import SettingsModal from '../components/settings_modal';
import { toast } from 'react-toastify';
import FlagModal from '../components/flag_modal';
import IssueVerifyModal from '../components/issue_verify_modal';
import VerificationModal from '../components/verification_modal';
import { ApiBaseUrl } from '../../http-common';
import StationAccordion from '../components/station_accordian';
import CreateStationFolderModal from '../components/create_station_folder_modal';
import RevisionHistoryService from '../services/rev_history_service';
import RevisionHistoryModal from '../components/create_rev_history_modal';


class DashboardScreen extends Component {
    state = {
        sourcePath: localStorage.getItem("inputsPath") || "",
        parsedStations: [],
        zones: [],
        selectedZone: "",
        loadingInitialData: true,
        uploadingStation: null,
        uploadingOutputDoc: null,
        showFlagModal: false,
        currentFlagStation: null,
        stationRecords: {},
        loadingRecords: {},
        verified_by: "",
        remarks: [""],
        showSettingsModal: false,
        showVerifyModal: false,
        currentVerifyStation: null,
        verifiedName: "",
        verifyRemarks: "",
        showIssueVerifyModal: false,
        currentIssueVerifyStation: null,
        currentIssueIndex: null,
        currentIssueRecordId: null,
        showCreateStationModal: false,
        newStationName: "",
        newStationZone: "",
        newStationInitialVersion: "2.0.0",
        searchTerm: "",
        showRevisionHistoryModal: false,
        currentRevisionStation: null,
        currentRevisionVersion: null,
        currentRevisionVersionId: null,
        revisionDocumentType: "tag_data_pdf",
        currentRevisionId: null,

        revisionDescription: "",
        revisionClosedDate: "",

        revisionHistory: [],
    };

    constructor(props) {
        super(props);
        this.accordionRef = React.createRef();
        // this.handleVerificationComplete = this.handleVerificationComplete.bind(this);
    }

    componentDidMount() {
        const { sourcePath } = this.state;

        const pathsReady = sourcePath;

        if (!pathsReady) {
            this.setState({ showSettingsModal: true });
        }
        this.fetchStations(true);
    }

    closeSettingsModal = () => {
        this.setState({
            showSettingsModal: false,
            inputsPath: localStorage.getItem("inputsPath") || "",
        });
    };



    isFlagSubmitDisabled = () => {
        const { verified_by, remarks } = this.state;
        return !verified_by.trim() || !remarks.some(remark => remark.trim());
    };

    isVerifySubmitDisabled = () => {
        const { verifiedName } = this.state;
        return !verifiedName.trim();
    };

    isIssueVerifySubmitDisabled = () => {
        const { verifyRemarks } = this.state;
        return !verifyRemarks.trim();
    };

    handleStationNameChange = (e) => {
        let value = e.target.value;

        value = value
            .toLowerCase()        // force lowercase
            .replace(/\s+/g, "") // remove spaces
            .replace(/[()[\]{}<>]/g, ""); // remove brackets

        this.setState({ newStationName: value });
    };

    createStation = async () => {
        const { sourcePath, newStationName, newStationZone, newStationInitialVersion } = this.state;

        if (!newStationName) {
            toast.error("Station name is required");
            return;
        }
        if (!newStationZone) {
            toast.error("Select a zone for the station");
            return;
        }
        try {
            const data = {
                folder_path: `${sourcePath}/Input_Documents`,
                folder_name: newStationName,
                zone: newStationZone,
                initial_version: newStationInitialVersion
            }
            const res = await StationService.createMainStationFolder(data);

            if (res.data.success) {
                toast.success(`Station "${newStationName}" created with version ${newStationInitialVersion}`);
                this.setState({
                    showCreateStationModal: false,
                    newStationName: "",
                    newStationZone: "",
                    newStationInitialVersion: "2.0.0"
                });
                window.location.reload();
            } else {
                toast.error(res.data.message || "Failed to create station");
            }

        } catch (err) {
            toast.error("Error creating station: " + err.message);
        }
    };

    fetchStations = async (isInitialLoad = false) => {
        try {
            const { sourcePath } = this.state;
            const res = await StationService.getStationDetails(`${sourcePath}`);
            const allPaths = res.data.contents;
            const parsed = this.parseStationFiles(allPaths);
            parsed.sort((a, b) => a.name.localeCompare(b.name));
            let zones = this.state.zones;
            let stationZones = {};
            try {
                const zoneResponse = await StationService.getDashboardZones();
                zones = zoneResponse.data?.zones || [];
                stationZones = zoneResponse.data?.station_zones || {};
            } catch (zoneError) {
                console.error("Failed to load station zones", zoneError);
            }
            const stationsWithZones = parsed.map((station) => ({
                ...station,
                zone: stationZones[station.name] || "SER"
            }));
            await new Promise(resolve => this.setState({
                parsedStations: stationsWithZones,
                zones
            }, resolve));
        } catch (err) {
            console.error(err);
            this.setState({ error: 'Failed to fetch station details.' });
        } finally {
            if (isInitialLoad) {
                this.setState({ loadingInitialData: false });
            }
        }
    };

    parseStationFiles = (filePaths) => {
        const stationsMap = {};

        filePaths.forEach((fullPath) => {
            const norm = fullPath.replace(/\\/g, '/');
            const inputMatch = norm.match(/Input_Documents\/([^\/]+)/);
            const outputMatch = norm.match(/Output_Documents\/([^/]+)/);
            const convertedMatch = norm.match(/Converted_Documents\/([^\/]+)/);

            let stationName = null;
            if (inputMatch) stationName = inputMatch[1];
            else if (outputMatch) stationName = outputMatch[1];
            else if (convertedMatch) stationName = convertedMatch[1];
            else return;

            if (!stationsMap[stationName]) {
                stationsMap[stationName] = {
                    name: stationName,
                    inputFiles: [],
                    outputDocumentFiles: [],
                    outputFiles: [],
                };
            }

            const s = stationsMap[stationName];
            if (norm.includes(`/Input_Documents/${stationName}/`)) {
                s.inputFiles.push(norm);
            }
            if (norm.includes(`/Output_Documents/${stationName}/`)) {
                s.outputDocumentFiles.push(norm);
            }
            if (norm.includes(`/Converted_Documents/${stationName}/`)) {
                s.outputFiles.push(norm);
            }
        });

        return Object.values(stationsMap);
    };

    openFlagModal = (station, version = null) => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        this.setState({
            showFlagModal: true,
            currentFlagStation: station,
            currentVersion: version,  // ← store it
            verified_by: user?.name || "",
            remarks: [""],
        });
    };

    closeFlagModal = () => {
        this.setState({ showFlagModal: false });
    };

    getSelectedVersionFromAccordion = (stationName) => {
        return this.accordionRef?.getSelectedVersion?.(stationName) || null;
    };

    addIssueInput = () => {
        this.setState(prevState => ({
            remarks: [...prevState.remarks, ""]
        }));
    };

    handleIssueChange = (index, value) => {
        this.setState(prevState => {
            const newRemarks = [...prevState.remarks];
            newRemarks[index] = value;
            return { remarks: newRemarks };
        });
    };

    handleFlagSubmit = async () => {
        const { currentFlagStation, currentVersion, verified_by, remarks } = this.state;
        const cleanRemarks = remarks.filter(r => r.trim());

        if (!verified_by.trim() || cleanRemarks.length === 0) return;

        try {
            const res = await StationService.raiseFlag(
                currentFlagStation,
                currentVersion,
                verified_by.trim(),
                cleanRemarks
            );

            if (res.data.success) {
                toast.success("Flag raised successfully");
                this.setState({
                    showFlagModal: false,
                    verified_by: "",
                    remarks: [""]
                });
                this.accordionRef.current?.fetchVerificationRecords?.(currentFlagStation, currentVersion);
            } else {
                toast.error("Failed to raise flag");
            }

        } catch (err) {
            toast.error("Network error");
        }
    };

    openVerifyModal = (station, version = null) => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        this.setState({
            showVerifyModal: true,
            currentVerifyStation: station,
            currentVersion: version,  // ← store it
            verifiedName: user?.name || "User",
            verifyRemarks: "",
        });
    };

    closeVerifyModal = () => {
        this.setState({ showVerifyModal: false });
    };


    handleVerifySubmit = async () => {
        const { currentVerifyStation, currentVersion, verifiedName, verifyRemarks } = this.state;

        if (!verifiedName.trim()) return;

        try {
            const response = await StationService.verifyStation(
                currentVerifyStation,
                currentVersion,
                verifiedName.trim(),
                verifyRemarks
            );

            const verifiedVersion = response?.data.current_version;

            toast.success("Station verified successfully");
            this.setState({ showVerifyModal: false });

            this.accordionRef.current?.handleVerificationComplete(currentVerifyStation, verifiedVersion);

        } catch (err) {
            toast.error("Verification failed");
        }
    };

    openIssueVerifyModal = (stationName, recordId, recordVerifiedBy, version = null) => {
        this.setState({
            showIssueVerifyModal: true,
            currentIssueRecordId: recordId,
            currentIssueVerifyStation: stationName,
            currentVersion: version,  // ← store it
            verifyRemarks: "",
            verifiedName: recordVerifiedBy,
            timestamp: new Date().toISOString()
        });
    };


    closeIssueVerifyModal = () => {
        this.setState({
            showIssueVerifyModal: false,
            currentIssueVerifyStation: null,
            currentIssueIndex: null
        });
    };

    handleIssueVerifySubmit = async () => {
        const { currentIssueRecordId, verifyRemarks, currentIssueVerifyStation } = this.state;

        if (!currentIssueRecordId) return;

        try {
            const res = await StationService.verifyIssue(currentIssueRecordId, verifyRemarks);

            toast.success("Issue verified and closed");
            this.setState({ showIssueVerifyModal: false });
            this.accordionRef.current?.fetchVerificationRecords?.(currentIssueVerifyStation);
        } catch (err) {
            toast.error("Failed to verify issue");
        }
    };

    formatTimestamp = (timestamp, dateOnly = false) => {
        return new Date(timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            ...(dateOnly ? {} : {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        });
    };


    getMimeType = (filename) => {
        const ext = filename.split('.').pop().toLowerCase();

        const mimeTypes = {
            pdf: "application/pdf",
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            bmp: "image/bmp",
            txt: "text/plain",
            csv: "text/csv",
            json: "application/json",
            xml: "application/xml",
            mp4: "video/mp4",
            mp3: "audio/mpeg",
            wav: "audio/wav",
            zip: "application/zip",
            rar: "application/vnd.rar",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ppt: "application/vnd.ms-powerpoint",
            pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        };

        return mimeTypes[ext] || "application/octet-stream";
    };

    handleFile = async (mode, folderType, station, subfolder, filename) => {
        const { sourcePath } = this.state;

        const filePath = `${sourcePath}/${folderType}/${station}${subfolder ? '/' + subfolder : ''}/${filename}`
            .replace(/\\/g, '/');

        try {
            const res = await StationService.openFile(
                { file_path: filePath, station: station },
                { responseType: 'blob' }
            );

            const mimeType = this.getMimeType(filename);
            const blob = new Blob([res.data], { type: mimeType });
            const url = URL.createObjectURL(blob);

            if (mode === "view") {
                window.open(url, "_blank");
            } else {
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
            }

            setTimeout(() => URL.revokeObjectURL(url), 10000);

        } catch (err) {
            console.error(`Error ${mode}ing file:`, err);
            alert(`Error ${mode}ing file.`);
        }
    };

    // downloadZip = async (folderType, station, subfolder) => {
    //     const { sourcePath } = this.state;

    //     const folderPath = `${sourcePath}/${folderType}/${station}${subfolder ? '/' + subfolder : ''}`
    //         .replace(/\\/g, '/');

    //     try {
    //         const res = await fetch(`${ApiBaseUrl}/download-zip`, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 station: station,
    //                 folder_path: folderPath
    //             }),
    //         });

    //         if (!res.ok) {
    //             const err = await res.json();
    //             throw new Error(err.message || "Download failed");
    //         }

    //         const blob = await res.blob();
    //         const url = URL.createObjectURL(blob);

    //         const a = document.createElement("a");
    //         a.href = url;
    //         a.download = `${folderType}_${station}_${subfolder || "files"}.zip`;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);

    //         setTimeout(() => URL.revokeObjectURL(url), 10000);

    //     } catch (err) {
    //         console.error("ZIP download error:", err);
    //         toast.error("Failed to download ZIP: " + err.message);
    //     }
    // };

    downloadZip = async (folderType, station, subfolder) => {
        const { sourcePath } = this.state;

        // Support both a single folderType (string) and multiple (array)
        const folderTypes = Array.isArray(folderType) ? folderType : [folderType];

        const folderPaths = folderTypes.map(type =>
            `${sourcePath}/${type}/${station}${subfolder ? '/' + subfolder : ''}`
                .replace(/\\/g, '/')
        );

        try {
            const res = await fetch(`${ApiBaseUrl}/download-zip`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    station: station,
                    folder_path: folderPaths          // always a list
                }),
            });

            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.message || "Download failed");
            }

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            // nicer name when multiple folders are requested
            const namePrefix = folderTypes[0];
            if (namePrefix == "Converted_Documents") {
                a.download = `${"Generated_Documents"}_${station}_${subfolder || "files"}.zip`;
            } else {
                a.download = `${namePrefix}_${station}_${subfolder || "files"}.zip`;
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            setTimeout(() => URL.revokeObjectURL(url), 10000);

        } catch (err) {
            console.error("ZIP download error:", err);
            toast.error("Failed to download ZIP: " + err.message);
        }
    };

    deleteFile = async (folderType, station, subfolder, filename) => {
        const { sourcePath } = this.state;

        const filePath = `${sourcePath}/${folderType}/${station}${subfolder ? '/' + subfolder : ''}/${filename}`
            .replace(/\\/g, '/');

        const fileKey = `${station}_${folderType}_${subfolder || "root"}_${filename}`;
        this.setState({ deletingDoc: fileKey });

        const confirmDelete = window.confirm(`Are you sure you want to delete ${filename}?`);
        if (!confirmDelete) {
            this.setState({ deletingDoc: null });
            return;
        }

        try {
            const res = await fetch(`${ApiBaseUrl}/delete-file`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    station: station,
                    file_path: filePath
                }),
            });

            const data = await res.json();

            if (data.success) {
                toast.success("File deleted successfully");
                await this.fetchStations();
                this.accordionRef.current?.fetchVerificationRecords?.(station);
            } else {
                toast.error("Delete failed: " + data.message);
            }

        } catch (err) {
            toast.error("Delete error: " + err.message);
        }

        this.setState({ deletingDoc: null });
    };

    fileInputRefs = {};

    handleAutoUpload = async (e, stationName) => {
        const file = e.target.files[0];
        if (!file) return; this.setState({ uploadingStation: stationName });
        const formData = new FormData(); formData.append("file", file);
        formData.append("station", stationName);
        formData.append("base_path", `${this.state.sourcePath}/Input_Documents/${stationName}/VERSION_IN_BACKEND`);
        try {
            const response = await fetch(`${ApiBaseUrl}/upload-file`,
                { method: "POST", body: formData, });
            const data = await response.json(); if (data.success) {
                toast.success("File uploaded successfully");
                this.fetchStations();
            } else {
                toast.error("Upload failed: " + data.message);
            }
        }
        catch (err) {
            toast.error("Upload error: " + err.message);

        } this.setState({ uploadingStation: null });
    };

    outputFileInputRefs = {};

    handleOutputUpload = async (e, stationName) => {
        const file = e.target.files[0];
        if (!file) return;

        const requiredFiles = [
            { name: "RFID_TIN_layout.png", folder: "schematic_plan" },
            { name: `RCT_${stationName}.xlsx`, folder: "tables" },
            { name: `TD_${stationName}.xlsx`, folder: "tables" },
            { name: `TOC_${stationName}.xlsx`, folder: "tables" },
        ];
        const requiredFile = requiredFiles.find(({ name }) => name === file.name);

        if (!requiredFile) {
            toast.error("Only the required RFID, RCT, TD, or TOC files can be uploaded.");
            e.target.value = "";
            return;
        }

        this.setState({ uploadingOutputDoc: stationName });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("station", stationName);
        formData.append(
            "base_path",
            `${this.state.sourcePath}/Output_Documents/${stationName}/VERSION_IN_BACKEND/${requiredFile.folder}`
        );

        try {
            const response = await fetch(`${ApiBaseUrl}/upload-file`, {
                method: "POST",
                body: formData,
            });
            const data = await response.json();

            if (data.success) {
                toast.success("File uploaded successfully");
                await this.fetchStations();
            } else {
                toast.error("Upload failed: " + data.message);
            }
        } catch (err) {
            toast.error("Upload error: " + err.message);
        } finally {
            this.setState({ uploadingOutputDoc: null });
            e.target.value = "";
        }
    };

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value.toLowerCase() });
    };

    openRevisionHistoryModal = async (
        station,
        versionId,
        version,
        documentType = "tag_data_pdf"
    ) => {

        try {

            const res = await RevisionHistoryService.getRevisionHistory(versionId, documentType);

            const revisionHistory = (res.data?.revision_history || [])
                .filter(item => item.document_type === documentType);
            const revision = revisionHistory[0];

            this.setState({

                showRevisionHistoryModal: true,

                currentRevisionStation: station,
                currentRevisionVersion: version,
                currentRevisionVersionId: versionId,
                revisionDocumentType: documentType,

                currentRevisionId: revision?.id || null,

                revisionHistory,

                revisionDescription: revision?.description || "",

                revisionClosedDate: revision?.closed_date
                    ? revision.closed_date.split("T")[0]
                    : ""
            });

        } catch (err) {

            toast.error("Failed to load revision history");

        }
    };

    closeRevisionHistoryModal = () => {
        const { currentRevisionStation, currentRevisionVersionId } = this.state;
        this.accordionRef.current?.loadRevisionHistoryPreview(
            currentRevisionStation,
            currentRevisionVersionId
        );

        this.setState({
            showRevisionHistoryModal: false,
            revisionDescription: "",
            revisionClosedDate: "",
            revisionHistory: [],
            revisionDocumentType: "tag_data_pdf",
            currentRevisionVersionId: null
        });
    };

    handleRevisionVersionChange = async (version) => {
        const versionObject = (this.accordionRef.current?.state.versionObjects?.[
            this.state.currentRevisionStation
        ] || []).find(item => item.version === version);
        if (!versionObject) return;

        try {
            const res = await RevisionHistoryService.getRevisionHistory(
                versionObject.id,
                this.state.revisionDocumentType
            );
            const revisionHistory = (res.data?.revision_history || [])
                .filter(item => item.document_type === this.state.revisionDocumentType);
            const revision = revisionHistory[0];
            this.setState({
                currentRevisionVersion: version,
                currentRevisionVersionId: versionObject.id,
                currentRevisionId: revision?.id || null,
                revisionHistory,
                revisionDescription: revision?.description || "",
                revisionClosedDate: revision?.closed_date
                    ? revision.closed_date.split("T")[0]
                    : ""
            });
        } catch (err) {
            toast.error("Failed to load revision history");
        }
    };

    handleRevisionDocumentTypeChange = async (documentType) => {
        this.setState({ revisionDocumentType: documentType }, () => {
            this.handleRevisionVersionChange(this.state.currentRevisionVersion);
        });
    };

    handleRevisionSubmit = async () => {

        const {
            currentRevisionId,
            revisionDescription,
            revisionClosedDate,
            currentRevisionVersionId
            , revisionDocumentType
        } = this.state;

        if (!revisionDescription.trim()) {
            return;
        }

        try {

            await RevisionHistoryService.updateRevision(
                currentRevisionId,
                {
                    version_id: currentRevisionVersionId,
                    description: revisionDescription,
                    closed_date: revisionClosedDate || null
                    , document_type: revisionDocumentType
                }
            );

            toast.success("Revision updated");

            const res = await RevisionHistoryService.getRevisionHistory(
                currentRevisionVersionId,
                revisionDocumentType
            );

            const revisionHistory = (res.data?.revision_history || [])
                .filter(item => item.document_type === revisionDocumentType);
            const revision = revisionHistory[0];

            this.setState({
                revisionHistory,
                revisionDescription: revision?.description || "",
                revisionClosedDate: revision?.closed_date
                    ? revision.closed_date.split("T")[0]
                    : "",
                currentRevisionId: revision?.id || null
            });

        } catch (err) {
            toast.error("Failed to update revision");
        }
    };

    handleDeleteRevision = async (revisionId) => {

        try {

            await RevisionHistoryService.deleteRevision(revisionId);

            toast.success("Revision deleted");

            const res = await RevisionHistoryService.getRevisionHistory(
                this.state.currentRevisionVersionId,
                this.state.revisionDocumentType
            );

            this.setState({
                revisionHistory: (res.data.revision_history || [])
                    .filter(item => item.document_type === this.state.revisionDocumentType)
            });

        } catch (err) {
            toast.error("Failed to delete revision");
        }
    };


    render() {
        const { parsedStations, showSettingsModal, loadingInitialData, zones, selectedZone } = this.state;
        const user = localStorage.getItem("user");
        const filteredStations = parsedStations.filter((station) =>
            station.name.toLowerCase().includes(this.state.searchTerm)
            && (!selectedZone || station.zone === selectedZone)
        );

        return (
            <div className="dashboard-container" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {showSettingsModal && <SettingsModal closeModal={this.closeSettingsModal} />}
                <Header />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 dashboard-content-column">
                            <div className='d-flex justify-content-between align-items-center sticky-top bg-white py-3'>
                                <h3 className="m-0" style={{ color: '#2c3e50', fontWeight: '600' }}>Stations Dashboard</h3>
                                <div style={{ width: "25%", border: "1px solid grey", borderRadius: "8px", }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search station..."
                                        onChange={this.handleSearchChange}
                                    />
                                </div>
                                <div className='col-md-3 d-flex justify-content-end align-items-center gap-2'>
                                    <select
                                        className="form-select"
                                        value={selectedZone}
                                        onChange={(event) => this.setState({ selectedZone: event.target.value })}
                                        aria-label="Filter stations by zone"
                                        style={{ maxWidth: "40%", borderRadius: "8px", border: "1px solid #83878b"}}
                                    >
                                        <option value="">All Zones</option>
                                        {zones.map((zone) => (
                                            <option key={zone.id} value={zone.name}>{zone.name}</option>
                                        ))}
                                    </select>
                                    <button
                                        className='btn py-2 px-4 d-flex align-items-center'
                                        style={{
                                            background: '#193e6c',
                                            fontSize: '1rem',
                                            color: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                        onClick={() => this.setState({
                                            showCreateStationModal: true,
                                            newStationZone: ""
                                        })}
                                    >
                                        <i className="bi bi-plus-circle me-1"></i> Create Station
                                    </button>
                                    {/* <Link to="/convert" style={{ textDecoration: "none" }}>
                                        <button
                                            className='btn py-2 px-4 d-flex align-items-center'
                                            style={{
                                                background: '#193e6c',
                                                fontSize: '1rem',
                                                color: 'white',
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                        >
                                            <i className="bi bi-arrow-repeat me-2"></i>
                                            Convert to Kernex
                                        </button>
                                    </Link> */}
                                </div>
                            </div>

                            <StationAccordion
                                ref={this.accordionRef}
                                parsedStations={filteredStations}
                                getCombinedRecords={this.getCombinedRecords}
                                openVerifyModal={this.openVerifyModal}
                                openFlagModal={this.openFlagModal}
                                openIssueVerifyModal={this.openIssueVerifyModal}
                                openRevisionHistoryModal={this.openRevisionHistoryModal}
                                formatTimestamp={this.formatTimestamp}
                                handleFile={this.handleFile}
                                downloadZip={this.downloadZip}
                                deleteFile={this.deleteFile}
                                handleAutoUpload={this.handleAutoUpload}
                                handleOutputUpload={this.handleOutputUpload}
                                uploadingStation={this.state.uploadingStation}
                                uploadingOutputDoc={this.state.uploadingOutputDoc}
                                deletingDoc={this.state.deletingDoc}
                                outputFileInputRefs={this.outputFileInputRefs}
                                fileInputRefs={this.fileInputRefs}
                                refreshStations={this.fetchStations}
                            />

                            {!loadingInitialData && !filteredStations.length && (
                                <div className="card border-0 shadow-sm text-center py-5" style={{ borderRadius: '12px' }}>
                                    <i className="bi bi-inbox text-muted" style={{ fontSize: '3rem' }}></i>
                                    <h5 className="mt-3" style={{ color: '#6c757d' }}>
                                        {parsedStations.length ? 'No stations found for the selected filters' : 'No stations available'}
                                    </h5>
                                    <p className="text-muted mb-0">
                                        {parsedStations.length
                                            ? 'Try selecting a different zone or changing your search.'
                                            : 'Create a station to get started.'}
                                    </p>
                                </div>
                            )}

                            {this.state.showFlagModal && (
                                <FlagModal
                                    show={this.state.showFlagModal}
                                    station={this.state.currentFlagStation}
                                    verified_by={this.state.verified_by}
                                    remarks={this.state.remarks}
                                    onClose={this.closeFlagModal}
                                    onVerifiedByChange={(val) => this.setState({ verified_by: val })}
                                    onRemarkChange={this.handleIssueChange}
                                    onAddIssue={this.addIssueInput}
                                    onSubmit={this.handleFlagSubmit}
                                    isSubmitDisabled={this.isFlagSubmitDisabled()}
                                    formatTimestamp={this.formatTimestamp}
                                />
                            )}

                            {this.state.showVerifyModal && (
                                <VerificationModal
                                    show={this.state.showVerifyModal}
                                    station={this.state.currentVerifyStation}
                                    verifiedName={this.state.verifiedName}
                                    verifyRemarks={this.state.verifyRemarks}
                                    onClose={this.closeVerifyModal}
                                    onRemarksChange={(val) => this.setState({ verifyRemarks: val })}
                                    onSubmit={this.handleVerifySubmit}
                                    isSubmitDisabled={this.isVerifySubmitDisabled()}
                                    formatTimestamp={this.formatTimestamp}
                                />
                            )}

                            {this.state.showIssueVerifyModal && (
                                <IssueVerifyModal
                                    show={this.state.showIssueVerifyModal}
                                    raisedBy={this.state.verifiedName}
                                    timestamp={this.state.timestamp}
                                    verifyRemarks={this.state.verifyRemarks}
                                    onClose={this.closeIssueVerifyModal}
                                    onRemarksChange={(val) => this.setState({ verifyRemarks: val })}
                                    onSubmit={this.handleIssueVerifySubmit}
                                    isSubmitDisabled={this.isIssueVerifySubmitDisabled()}
                                    formatTimestamp={this.formatTimestamp}
                                />
                            )}

                            {this.state.showCreateStationModal && (
                                <CreateStationFolderModal
                                    show={this.state.showCreateStationModal}
                                    stationName={this.state.newStationName}
                                    zones={zones}
                                    stationZone={this.state.newStationZone}
                                    onClose={() => this.setState({
                                        showCreateStationModal: false,
                                        newStationName: "",
                                        newStationZone: "",
                                        newStationInitialVersion: "2.0.0"
                                    })}
                                    onChange={this.handleStationNameChange}
                                    initialVersion={this.state.newStationInitialVersion}
                                    onVersionChange={(version) => this.setState({ newStationInitialVersion: version })}
                                    onZoneChange={(zone) => this.setState({ newStationZone: zone })}
                                    onSubmit={this.createStation}
                                    isSubmitDisabled={
                                        !this.state.newStationName.trim()
                                        || !this.state.newStationZone
                                        || !this.state.newStationInitialVersion.trim()
                                    }
                                />
                            )}

                            {this.state.showRevisionHistoryModal && (
                                <RevisionHistoryModal
                                    show={this.state.showRevisionHistoryModal}
                                    station={this.state.currentRevisionStation}
                                    version={this.state.currentRevisionVersion}
                                    availableVersions={
                                        this.accordionRef.current?.state.versionObjects?.[
                                            this.state.currentRevisionStation
                                        ] || []
                                    }
                                    documentType={this.state.revisionDocumentType}
                                    description={this.state.revisionDescription}
                                    closedDate={this.state.revisionClosedDate}
                                    revisionHistory={this.state.revisionHistory}
                                    onClose={this.closeRevisionHistoryModal}
                                    onDescriptionChange={(val) => this.setState({ revisionDescription: val })}
                                    onClosedDateChange={(val) => this.setState({ revisionClosedDate: val })}
                                    onVersionChange={this.handleRevisionVersionChange}
                                    onDocumentTypeChange={this.handleRevisionDocumentTypeChange}
                                    onSubmit={this.handleRevisionSubmit}
                                    onDelete={this.handleDeleteRevision}
                                    isSubmitDisabled={!this.state.revisionDescription.trim()}
                                    formatTimestamp={this.formatTimestamp}
                                />
                            )
                            }
                        </div>
                    </div>
                </div>
                {loadingInitialData && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                        role="status"
                        aria-live="polite"
                        style={{ zIndex: 2000, backgroundColor: 'rgba(248,249,250,0.92)' }}
                    >
                        <span className="spinner-border text-primary mb-3" aria-hidden="true"></span>
                        <span className="fw-semibold text-secondary">Loading station dashboard...</span>
                    </div>
                )}
            </div>
        );
    }
}

export default DashboardScreen;
